import React, { useEffect } from 'react';
import { useState } from 'react';
import { Form, Button, Spinner, Col, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion } from "react-bootstrap";
import { FaAngleDoubleDown } from 'react-icons/fa';
import { DivisionWiseSalesPerformanceVW, currentMonthWorkingDays } from '../Redux/MapAction';
import LoadingSpinner from '../../modules/Billing/Components/LoadingSpinner';
import { numberFormat } from '../../Global/numberFormat';
import DownloadDropdown from "../../modules/master/PrintDwopdown/ExcelDawnload";

import InfiniteScroll from 'react-infinite-scroll-component';
import SalesPerformanceTable from './SalesPerformanceTable';


const DivisionWiseSalesPerformance = () => {

      
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const handleAccordionToggle = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    const currentDate = new Date();
    const initialMonth = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}`;
    const [selectedMonth, setSelectedMonth] = useState(initialMonth);

    // const [startDate, setStartDate] = useState(initialMonth);
    // const [toDate, setToDate] = useState(initialMonth);

    const handleChangeStartDate = (event) => {
       // alert(event.target.value)
        setStartDate(event.target.value);
        if(toDate < event.target.value)
        {
           setStartDate(toDate);
        }
        
    };

     const handleChangeTodate = (event) => {
        setToDate(event.target.value);

        if(startDate > event.target.value)
        {
           setToDate(startDate);
        }
    };

    

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const pageSize = 10;

    const [startDate, setStartDate] = useState(initialMonth); // you already have this
    const [toDate, setToDate] = useState(initialMonth);       // same here

    const divisionSalesPerformanceDataViews = useSelector(state => state?.mapData?.divisionSalesPerformanceDataView?.allData) || [];
    const totalCount = useSelector(state => state?.mapData?.divisionSalesPerformanceDataView?.totalCount) || 0;
    const isLoading = useSelector(state => state?.mapData?.divisionSalesPerformanceDataViewIsLoading);

    // 📥 Initial Load
    useEffect(() => {
        setPage(1);
        dispatch(DivisionWiseSalesPerformanceVW(startDate, toDate, 1, pageSize));
    }, [startDate, toDate]); // load when date range changes

    // 🔄 Load more function
    const loadMoreData = () => {
        if (divisionSalesPerformanceDataViews.length < totalCount && !isLoading) {
            const nextPage = page + 1;
            dispatch(DivisionWiseSalesPerformanceVW(startDate, toDate, nextPage, pageSize));
            
            setPage(nextPage);
        }
        
    };

    // 🆕 When user manually triggers refresh/filter
    const handleSummeryReport = async () => {
        setPage(1);
        dispatch(DivisionWiseSalesPerformanceVW(startDate, toDate, 1, pageSize));
    };

    

    // useEffect(() => {
    //     initialData();
    // }, [dispatch])

    // const initialData = async () => {
    //     await dispatch(DivisionWiseSalesPerformanceVW(startDate, toDate))
    //     await dispatch(currentMonthWorkingDays())

    // }
    // const divisionSalesPerformanceDataViews = useSelector(state => state?.mapData?.divisionSalesPerformanceDataView?.allData);
    const workingDays = useSelector(state => state?.mapData?.currentMonhWorking?.allData);


    console.log('workingDays', workingDays?.totWorkingDay)

    const divisionSalesPerformanceDataViewIsLoading = useSelector(state => state?.mapData?.divisionSalesPerformanceDataViewIsLoading);
    const monthNames = [
        "January", "February", "March", "April", "May", "June", "July",
        "August", "September", "October", "November", "December"
    ];
    const monthNumber = divisionSalesPerformanceDataViews && divisionSalesPerformanceDataViews.length > 0 ? divisionSalesPerformanceDataViews[0]?.month : null;
    const monthName = monthNames[monthNumber - 1]; // Adjusting index since array is zero-based
 
    return (
        <div className='container ims-division-wise-report'>



            <div className=' container-fluid top_card3-map rounded mb-5'>
                <Accordion activeKey={isAccordionOpen ? "1" : "0"}>

                    <Accordion.Toggle as={Button} variant="link" eventKey="1" className="arrayButton" onClick={handleAccordionToggle}>
                        <div>
                            <div className="dailysales text-center dailysalesmargin dailysalesfont row  ">
                                <span className="sales-title-map" style={{ width: '400px', margin: 'auto' }} >Division wise Sales Performance
                                    <div>
                                        <FaAngleDoubleDown className="float-right toparrow blink-text dropdownArrow" />
                                        <span className="clickHere float-right">
                                            {isAccordionOpen ? "Click to Close" : "Click to Expand"}
                                        </span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1" onEnter={() => setIsAccordionOpen(true)} onExit={() => setIsAccordionOpen(false)}>
                        <div>
                            <div className="row d-flex justify-content-center bg-blue ">



                                <div className="col-md-1.5 d-flex py-2 align-items-center justify-content-md-start justify-content-center">
                                    
                                        <Form.Group as={Col} controlId="formGridState">
                                            <label className="form-label text-light mb-0 text-right mr-3">From Month</label>
                                            <input
                                            type="month"
                                            placeholder="Enter From Month"                                                   
                                            value={startDate}
                                            className="form-control cusheight"
                                            onChange={handleChangeStartDate}
                                            />
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} controlId="formGridState">
                                            
                                        <label className="form-label text-light mb-0 text-right mr-3">To Month </label>
                                            <input
                                            type="month"
                                            placeholder="Enter To Month"                                                   
                                            value={toDate}
                                            className="form-control cusheight "
                                            onChange={handleChangeTodate}
                                            />
                                        </Form.Group>
                                              
                                    
                                    

                                    <div className="col-md-1.5 d-flex justify-content-center mt-5 ml-5">
                                   
                                        {toDate !== null ? (
                                            <button className="btn btn-primary btn-sm " onClick={() => handleSummeryReport()}>Filter</button>
                                            ) : null}
                                            
                                        </div>
                                </div>


                                
                            </div>

                        </div>

                    </Accordion.Collapse>
                </Accordion>
            </div>
           
            {
                divisionSalesPerformanceDataViewIsLoading &&
                <LoadingSpinner />

            }


            <Form>
                {/* your date pickers and other UI... */}
                <Button onClick={handleSummeryReport}>Load Data</Button>
            </Form>

           <InfiniteScroll
                dataLength={divisionSalesPerformanceDataViews.length}
                next={loadMoreData}
                hasMore={divisionSalesPerformanceDataViews.length < totalCount}
                loader={<h4>Loading...</h4>}
                endMessage={<p className="text-center">No more records</p>}
            >

            
                {/* <SalesPerformanceTable data={divisionSalesPerformanceDataViews} /> */}
                <SalesPerformanceTable data={divisionSalesPerformanceDataViews}/>
                {/* <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Zone</th>
                            <th>Division</th>
                            <th>Area</th>
                            <th>Territory</th>
                            <th>SO Qty</th>                           
                        </tr>
                    </thead>
                    <tbody>
                        {divisionSalesPerformanceDataViews.map((item, index) => (
                            <tr key={index}>
                                <td>{item.allId}</td>
                                <td>{item.zoneName}</td>
                                <td>{item.divisionName}</td>
                                <td>{item.areaName}</td>
                                <td>{item.territoryName}</td>
                                <td>{item.soQty}</td>                               
                            </tr>
                        ))}
                    </tbody>
                </table> */}
            </InfiniteScroll>

            {/* {!divisionSalesPerformanceDataViewIsLoading && <>
                <p className='export-for-excel'>
                    <DownloadDropdown excelname='Division wise ims Report' />
                </p>
                {divisionSalesPerformanceDataViews?.length <= 0 ? <p className='noAvailableata'>No Available data here</p> :

                    <div className="table-container">

                        <table id="table-to-xls" className="territory-table">
                            <thead className="bg-blue-100">
                            <tr>
                                <th className="border p-2">#</th>
                                <th className="border p-2">Zone</th>
                                <th className="border p-2">Division</th>
                                <th className="border p-2">Area</th>
                                <th className="border p-2">Territory</th>
                                <th className="border p-2">SO Name</th>
                                <th className="border p-2">SO Qty</th>
                                <th className="border p-2">SO Drop Qty</th>
                                <th className="border p-2">Distributor Drop</th>
                                <th className="border p-2">perSO IMS</th>
                                <th className="border p-2">Dist. Stock</th>
                                <th className="border p-2">Total IMS</th>
                                <th className="border p-2">Working Days</th>
                                <th className="border p-2">Passed Days</th>
                            </tr>
                            </thead>
                            <tbody className="text-center">
                                {divisionSalesPerformanceDataViews?.map((row, idx) => (
                                <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                                    <td className="border px-2 py-1 text-center">{idx + 1}</td>
                                    <td className="border px-2 py-1">{row.zoneName}</td>
                                    <td className="border px-2 py-1">{row.divisionName}</td>
                                    <td className="border px-2 py-1">{row.areaName}</td>
                                    <td className="border px-2 py-1">{row.territoryName}</td>
                                    <td className="border px-2 py-1">{row.soName}</td>
                                    <td className="border px-2 py-1 text-center">{row.soQty}</td>
                                    <td className="border px-2 py-1 text-center">{row.soDropQty}</td>
                                    <td className="border px-2 py-1 text-center">{row.distDropQty}</td>
                                    <td className="border px-2 py-1 text-center">{row.perSoIms}</td>
                                    <td className="border px-2 py-1 text-center">{row.distStockAmount}</td>
                                    <td className="border px-2 py-1 text-center">{row.totImsCm}</td>
                                    <td className="border px-2 py-1 text-center">{row.totWorkingDay}</td>
                                    <td className="border px-2 py-1 text-center">{row.passWorkingDay}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>                        
                    </div>
                }
            </>

            } */}
        </div>
    );
};

export default DivisionWiseSalesPerformance;